import { Box, Button, Grid, Modal, Typography, } from "@mui/material";
import Table, { ExtendedColumnType } from "components/Table";
import _ from "lodash";
import { useEffect, useState } from "react";
import { useMutation, useQuery, useQueryClient } from "react-query";
import { ResType } from "types";
import { createGstrPromiseClient, getGstrRecords, exportGstr1 } from "api/services/clients/gstr-clients";
import { snack } from "components/toast";
import React from "react";
import AddGstRecord from "views/register/GstReturns/AddGstRecord";
import { CLIENT_CATEGORIES, RegularTaxHeadings, SortDirection } from "data/constants";
import { getGstFinancialYears } from "utils/FinancialYears";
import FloatingButton from "components/FloatingButton";
import FilterAltOutlinedIcon from "@mui/icons-material/FilterAltOutlined";
import GstReturnsTracker from "views/register/Filter";
import { useSelector } from "react-redux";
import { selectGstRegister } from "redux/reducers/gstRegisterSlice";
import PeriodSelect from "views/register/GstReturns/YearmonthPeriodSelect";
import AppliedFilters from "views/register/ApplidedFilters";
import { useLocation } from "react-router-dom";
import { handleError } from "utils/handleError";
import { getCurrentFormattedDateTime } from "utils";
import sortHandler from "components/Table/SortHandler";
import { usePermissions } from "context/PermissionsProvider";
import { Permissions } from "data/permissons";
import { completeTaskGstrOne } from "api/services/gstr/config";
import Loader from "components/Loader";
import { exportErrorList } from "api/services/reports";

function GstrTaskView() {
  const financialYears = getGstFinancialYears();
  const { permissions } = usePermissions();
  const [selected, setSelected] = useState<any[]>([]);
  const currentMonth = new Date().getMonth();
  const adjustedMonthIndex = currentMonth === 0 ? 12 : currentMonth;
  const reqMonth = adjustedMonthIndex < 10 ? `0${adjustedMonthIndex}` : `${adjustedMonthIndex}`;
  const [selectedYear, setSelectedYear] = React.useState(financialYears[0]);
  const [selectedMonth, setSelectedMonth] = React.useState(reqMonth);
  const [open, setOpen] = useState(false);

  const [page, setPage] = useState<number>(0);
  const [pageCount, setPageCount] = useState<number>(10);
  const [filters, setFilters] = useState({
    labels: [],
    search: "",
  });
  const [tableData, setTableData] = useState<any[]>([]);
  const [lodd, setLoad] = useState<boolean>(false);
  const queryClient = useQueryClient();
  const [openFilter, setOpenFilter] = useState<boolean>(false);
  const states = useSelector(selectGstRegister);
  const [sort, setSort] = useState<any>({});
  const location = useLocation();
  const state: any = location.state;
  const [openModal, setOpenModal] = useState(false);
  const handleOpen = () => setOpenModal(true);
  const handleClose = () => {
    setOpenModal(!openModal);
    // setOpen(false);
  };
  let [errorsListModal, setErrorsListModal]: any = useState([]);



  useEffect(() => {
    setSelected([]);
  }, [selectedYear, selectedMonth]);

  const monthLydefaultColumns: Array<ExtendedColumnType> = [
    {
      key: 'client.clientId', title: "Client ID",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC, default: true, 
      render: (row: any) => row?.client ? row?.client?.clientId : row?.clientGroup?.clientId
    },
    {
      key: "category",
      title: "Category",
      // sort: true,
      // active: false,
      // direction: SortDirection.ASC, default: true,
      render: (rowData) => {
        return (
          <>
            {CLIENT_CATEGORIES.map((item: any) => {
              return item.value == rowData?.client?.category ? item.label : "";
            })}
          </>
        );
      },
    },
    {
      key: "client.gstNumber", title: "GSTIN", default: true, render: (row: any) => row?.client ? row?.client?.gstNumber : row?.clientGroup?.gstNumber
    },
    {
      key: "client.displayName", title: "Client Name",
      //  sort: true,
      // active: false,
      // direction: SortDirection.ASC, default: true,
      render: (row: any) => row?.client ? row?.client?.displayName : row?.clientGroup?.displayName,
    },
    {
      key: "status", title: "Return Status", sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => row?.returnsData?.[0]?.status === 'Filed' ? <Typography color='green'>{row?.returnsData?.[0]?.status} </Typography>
        : (row?.returnsData?.[0]?.status === 'NA') ? (<Typography color='red'>{row?.returnsData?.[0]?.status} </Typography>) : <Typography color='red'>Not Filed</Typography>
    },
    {
      key: "dof", title: "Date of Filing", sort: true,
      active: false,
      direction: SortDirection.ASC, default: true,
      render: (row: any) => row?.returnsData?.[0]?.dof ? row?.returnsData?.[0]?.dof : "-"
    },
    {
      key: "arn", title: "ARN", default: true,
      render: (row: any) => row?.returnsData?.[0]?.arn ? row?.returnsData?.[0]?.arn : "-"
    },
  ]


  const { data, isLoading }: ResType = useQuery(
    [
      "clients-gst-returns",
      {
        limit: pageCount,
        offset: page * pageCount,
        query: {
          ...filters,
          labels: filters.labels.map((c: any) => c?.id),
          sort
        },
        type: 'regular_taxpayer',
        rtntype: 'GSTR1',
        selectedYear: selectedYear,
        selectedMonth,
        category: states?.appliedFilters?.category["value"] === undefined ? [] : [states?.appliedFilters?.category["value"]],
        subCategory: states?.appliedFilters?.subCategory.map((c: any) => c?.value),
        status: states?.appliedFilters?.status["value"] === undefined ? [] : [states?.appliedFilters?.status["value"]],
        jurisdiction: states?.appliedFilters?.jurisdiction["value"] === undefined ? [] : [states?.appliedFilters?.jurisdiction["value"]],
      },
    ],
    getGstrRecords, {
    enabled: !!selectedYear && !!selectedMonth && (permissions.includes(Permissions.VIEW_ALL_CLIENT_MANAGERS) || permissions.includes(Permissions.VIEW_ASSIGNED_CLIENT_MANAGERS)),

    onSuccess: (res: any) => {
      setTableData(res?.data?.result)
    },
    onError: (err: any) => {
      if (!err?.error) {
        snack.error(`An error occurred while fetching register data`);
      }
    }
  });
  const [columns, setColumns] = useState(_.cloneDeep(monthLydefaultColumns));
  const handleSort = (v: any) => {
    sortHandler({
      key: v.key,
      columns,
      sortState: sort,
      setSortState: setSort,
      setColumns: setColumns,
    });
  };
  const totalCount = data?.data?.count;
  const { mutate, isLoading: loading } = useMutation(createGstrPromiseClient, {
    onSuccess: (res) => {
      setTimeout(() => {
        queryClient.invalidateQueries("clients-gst-returns");
        setLoad(false);
        snack.success("Sync Successful");
      }, 200);
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const getGstReturnClients = async () => {
    if (!selectedYear) return snack.error('Select Financial Year');
    if (!selectedMonth) return snack.error('Select Month');
    if (!selected.length) return snack.error('Select At least one Client');

    let clientDetails: any = []
    for (let i of selected) {
      // clientDetails.push({
      //   id: i?.id,
      //   clientId: i?.client?.id,
      //   gstNumber: i?.client?.gstNumber,
      //   returnsData: i?.returnsData,
      //   clientGroupId: i?.clientGroup?.id
      // });

      if (i?.client) {
        clientDetails.push({
          id: i?.id,
          clientId: i?.client?.id,
          gstNumber: i?.client?.gstNumber,
          returnsData: i?.returnsData,
          clientGroupId: null
        });
      } else if (i?.clientGroup) {
        clientDetails.push({
          id: i?.id,
          clientId: null,
          gstNumber: i?.clientGroup?.gstNumber,
          returnsData: i?.returnsData,
          clientGroupId: i?.clientGroup?.id
        });
      } else {
        console.warn("Skipping item without client or clientGroup", i);
      }
    }

    console.log("clientDetailss", clientDetails)
    let clientDetailss = clientDetails.filter((row: any) => {
      return (!row?.returnsData?.length);
    });
    if (!clientDetailss.length) {
      return snack.error("One-Time Sync! Your GST Returns data has been synced and is ready to use. Since there's no option to revise past GST returns, your data will stay synced.")
    };
    setLoad(true);

    mutate({
      financialYear: selectedYear,
      clientDetails: clientDetailss,
    });
  };


  const { mutate: mutate1 } = useMutation(exportGstr1, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const formattedDateTime = getCurrentFormattedDateTime();
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = file;
      link.download = `GSTR-1/1FF Report ${formattedDateTime}.xlsx`;
      link.click();
      snack.success("Exported Successfully");
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });



  const { mutate: mutateCompleteGstrOne, isLoading: isLoadingCompleteTasks } = useMutation(completeTaskGstrOne, {
    onSuccess: (res: any) => {
      console.log(res?.data)
      if (res?.data?.gstr1TasksCount) {
        snack.success(`${res?.data?.gstr1TasksCount} GSTR-1 tasks completed`,)
      }
      if (res?.data?.gstr3BTasksCount) {
        snack.success(`${res?.data?.gstr3BTasksCount} GSTR-3B tasks completed`,)
      }

      if (res?.data?.Gstr9TasksCount) {
        snack.success(`${res?.data?.Gstr9TasksCount} GSTR-9 tasks completed`,)
      }

      if (res?.data?.errorMsg) {
        res?.data?.errorMsg?.map((item) => {
          snack.error(item)
        }
        )
      }

      if (res?.data?.successRows.length > 0) {
        setErrorsListModal(res?.data?.successRows)
        handleOpen();
      }
    },
    onError: (err: any) => {
      snack.error(err);
      snack.error(handleError(err));
    },
  });


  const { mutate: getErrorFile, isLoading: loadingErrorFile } = useMutation(exportErrorList, {
    onSuccess: (res: any) => {
      const arr = new Uint8Array(res.data?.data);
      const blob = new Blob([arr], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      const file = window.URL.createObjectURL(blob);
      let link = document.createElement("a");
      link.href = file;
      link.download = "Completed Tasks.xlsx";
      link.click();
      snack.success("Exported successfully");
    },
    onError: (err: any) => {
      snack.error(err.response.data.message);
    },
  });

  const handleExport = () => {
    getErrorFile(errorsListModal);
  };

  // const handleExport = () => {
  //   mutate1({
  //     ...state,
  //     limit: pageCount,
  //     offset: page * pageCount,
  //     query: {
  //       ...filters,
  //       labels: filters.labels.map((c: any) => c?.id),
  //     },
  //     type: 'regular_taxpayer',
  //     rtntype: 'GSTR1',
  //     selectedYear: selectedMonth === '03' ? incrementFinancialYear(selectedYear) : selectedYear,
  //     selectedMonth,
  //     category: states?.appliedFilters?.category["value"] === undefined ? [] : [states?.appliedFilters?.category["value"]],
  //     subCategory: states?.appliedFilters?.subCategory.map((c: any) => c?.value),
  //     status: states?.appliedFilters?.status["value"] === undefined ? [] : [states?.appliedFilters?.status["value"]],
  //     jurisdiction: states?.appliedFilters?.jurisdiction["value"] === undefined ? [] : [states?.appliedFilters?.jurisdiction["value"]],

  //   });
  // };

  const style = {
    position: "absolute" as "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    border: "2px solid #000",
    boxShadow: 24,
    p: 4,
  };


  return (
    <Box m={1}>
      <Grid container spacing={2} mb={2} alignItems="center">
        <Grid item xs={3} order={{ xs: 2, sm: 2, md: 1 }}>
          <PeriodSelect
            selectedYear={selectedYear}
            setSelectedYear={setSelectedYear}
            selectedMonth={selectedMonth}
            setSelectedMonth={setSelectedMonth}
          />
        </Grid>

        <Grid item xs={6} md={6} textAlign={{ xs: "center", md: "right" }} order={3}>
          <Box display="inline-block">
            <Button
              size="large"
              color="secondary"
              variant="outlined"
              onClick={() => { getGstReturnClients(); }}
              sx={{ mr: 3 }}
            >
              Sync With Portal
            </Button>
            <Button
              onClick={() => mutateCompleteGstrOne({})}
              variant="outlined"
              sx={{ mr: 1 }}
            >
              Sync With Atom
            </Button>
          </Box>
        </Grid>
      </Grid>
      <AppliedFilters />
      <Table
        sx={{ mt: 1 }}
        loading={isLoading || lodd}
        data={tableData || []}
        columns={columns}
        sortHandler={handleSort}
        selection={{ selected, setSelected }}
        pagination={{ totalCount, page, setPage, pageCount, setPageCount }}
        heading={RegularTaxHeadings.GSTR1}

      />
      {/* <FloatingButton
        onClick={() => {
          setOpen(true);
        }}
      />
      <AddGstRecord open={open} setOpen={setOpen} title={`Add Record`} /> */}
      {/* <GstReturnsTracker
        open={openFilter}
        setOpen={setOpenFilter}
      /> */}
      {isLoadingCompleteTasks ? (
        <Modal
          open={isLoadingCompleteTasks}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box
            sx={{
              ...style,
              zIndex: "100",
              height: "30vh",
              width: "60vw",
              display: "flex",
              flexDirection: "column",
              justifyContent: "center",
              alignContent: "center",
              overflow: "auto",
            }}
          >
            <Typography textAlign={"center"} variant="h6">Atom Pro Sync Tasks</Typography>
            <Typography textAlign={"center"} sx={{ marginTop: "8px" }}>
              Thanks for your patience! We're currently Sync with Auto Pro.
              This may take a few minutes. Please wait...
            </Typography>
            <Loader minHeight={"70px"} />
          </Box>
        </Modal>
      ) : null}
      {!isLoadingCompleteTasks ? (
        <Modal
          open={openModal}
          onClose={handleClose}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={{ ...style, maxHeight: "80vh", width: "70vw", overflow: "auto" }}>
            <Typography id="transition-modal-title" variant="h6" component="h2">
              Completed Task List
            </Typography>
            <Typography id="transition-modal-description" sx={{ mt: 2 }}>
              <ol>
                {errorsListModal.map((item, index) => (
                  <li key={index}>{item}</li>
                ))}
              </ol>
            </Typography>
            <Box>
              <Button variant="outlined" color="secondary" sx={{ m: 2 }} onClick={handleClose}>
                Close
              </Button>
              <Button variant="outlined" color="secondary" onClick={handleExport}>
                Export to Excel
              </Button>
            </Box>
          </Box>
        </Modal>
      ) : null}

    </Box >
  );
}

export default GstrTaskView;
